import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3057cfeb&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3057cfeb')) {
      api.createRecord('3057cfeb', component.options)
    } else {
      api.reload('3057cfeb', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=3057cfeb&", function () {
      api.rerender('3057cfeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/header/Header.vue"
export default component.exports